export function initAccordions() {
  const titles = document.querySelectorAll(".coop-c-accordion__item, .coop-c-accordion__item-no-blue-line");
  const activeTitles = document.querySelectorAll(
    ".active"
  );

  [...titles].map((item) => {
    item.addEventListener("click", function () {
      const section = this.nextElementSibling;
      this.classList.toggle("active");
      if (section.style.maxHeight) {
        section.style.maxHeight = null;
      } else {
        section.style.maxHeight = section.scrollHeight + "px";
      }
    });
  });

  [...activeTitles].map((item) => {
    const section = item.nextElementSibling;
    if (section.style.maxHeight) {
      section.style.maxHeight = null;
    } else {
      section.style.maxHeight = section.scrollHeight + "px";
    }
  });
}
